module.exports = __webpack_public_path__ + "static/media/MainHeader.9f1a98ab.png";